export default function TermsPage() {
    return (
        <div data-testid="terms-page" className="bg-zinc-50 min-h-screen">
            <div className="max-w-3xl mx-auto px-6 py-16">
                <p className="label-tiny">Juridisch</p>
                <h1 className="font-display text-5xl mt-2">Algemene Voorwaarden</h1>
                <p className="text-zinc-500 mt-2 text-sm">Laatste update: februari 2026</p>

                <div className="mt-10 space-y-8 text-sm leading-relaxed text-zinc-700">
                    <section>
                        <h2 className="font-display text-2xl text-zinc-950">1. Identiteit</h2>
                        <p className="mt-3">VdS Design — Gentse baan 7, 9100 Sint-Niklaas, België.<br/>
                        Email: vdsdesign2020@gmail.com — WhatsApp: +32 491 46 82 80</p>
                    </section>
                    <section>
                        <h2 className="font-display text-2xl text-zinc-950">2. Bestelling &amp; productie</h2>
                        <p className="mt-3">Elk product is een <strong>maatwerk artikel</strong>. Productie start pas na ontvangst van betaling. Verzending gebeurt 3 tot 5 werkdagen na ontvangst van de betaling via bpost.</p>
                    </section>
                    <section>
                        <h2 className="font-display text-2xl text-zinc-950">3. Prijzen &amp; betaling</h2>
                        <p className="mt-3">Alle prijzen in euro, inclusief BTW. Verzendkosten worden bovenop het totaal aangerekend en zijn duidelijk vermeld bij de checkout. Aanvaarde betaalmethoden: SEPA QR-code en bankoverschrijving (IBAN BE16 0004 1120 9874).</p>
                    </section>
                    <section>
                        <h2 className="font-display text-2xl text-zinc-950">4. Herroepingsrecht</h2>
                        <p className="mt-3">Omdat onze producten <strong>op maat geproduceerd</strong> worden, geldt het wettelijk herroepingsrecht van 14 dagen <strong>niet</strong> (artikel VI.53 Wetboek Economisch Recht). Bij productiefouten of beschadiging tijdens transport vervangen wij het artikel uiteraard gratis.</p>
                    </section>
                    <section>
                        <h2 className="font-display text-2xl text-zinc-950">5. Retour bij defect</h2>
                        <p className="mt-3">Defecte producten kunnen binnen 14 dagen geretourneerd worden naar: <strong>VdS Design, Gentse baan 7, 9100 Sint-Niklaas</strong>. Contacteer ons eerst via WhatsApp of email.</p>
                    </section>
                    <section>
                        <h2 className="font-display text-2xl text-zinc-950">6. Auteursrecht ontwerpen</h2>
                        <p className="mt-3">Bij het uploaden van eigen afbeeldingen of foto&apos;s verklaar je dat je over de nodige rechten beschikt. Het uploaden van auteursrechtelijk beschermd materiaal (logo&apos;s van merken, copyrighted afbeeldingen, etc.) is jouw verantwoordelijkheid. VdS Design kan niet aansprakelijk worden gesteld voor inbreuken.</p>
                    </section>
                    <section>
                        <h2 className="font-display text-2xl text-zinc-950">7. Aansprakelijkheid</h2>
                        <p className="mt-3">VdS Design is enkel aansprakelijk voor directe schade. Onze aansprakelijkheid is in elk geval beperkt tot het aankoopbedrag van de bestelling.</p>
                    </section>
                    <section>
                        <h2 className="font-display text-2xl text-zinc-950">8. Toepasselijk recht</h2>
                        <p className="mt-3">Op deze voorwaarden is Belgisch recht van toepassing. Geschillen worden voorgelegd aan de rechtbanken van Sint-Niklaas.</p>
                    </section>
                </div>
            </div>
        </div>
    );
}
